import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import stylesContainer from "../style.module.scss";
import Filter from "./Filter";

interface IProps {
    onSearch(value: string): void
}

export default function HeaderTab(props: IProps) {
    const { onSearch } = props;

    return <div className={stylesContainer['tab-header']}>
        <Input
            className="w-full max-w-[320px] h-[36px] rounded-[36px]"
            placeholder="Search request by ID, site, desc."
            allowClear
            onChange={({ target: { value } }: any) => onSearch(value)}
            suffix={<SearchOutlined className='text-comment' />}
        />
        <Filter />
    </div>;
}